<div style="background: #F5F6FA">
  <div class="row">
    <h2 class="ambrolive_text"> Ambro Live</h2>
    <div class="row">
      <div class="ambrolive_block">
        <!--Ambro live-->
        <div class="row">
          <div class="transactions_block">
            <div class="col-xs-12">
              <div class="row">
                <div class="row row-flex">
                  <!--Providers-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview" *ngIf="appPermission.providersFlag">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#todayProviderModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{providerBusinessEntities && providerBusinessEntities.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Providers</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/Provider.png" height="50" width="50"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{providerBusinessEntities && providerBusinessEntities.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Farm-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#todayFarmModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{currentDayFarmSites && currentDayFarmSites.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Farm</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/Farm.png" height="40" width="40"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{currentDayFarmSites && currentDayFarmSites.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--culture-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#cultureModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{pondCultures && pondCultures.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Cultures</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/cultures.png" height="50" width="50"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{pondCultures && pondCultures.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--tank-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#todayTanksModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{currentDayCustomerPonds && currentDayCustomerPonds.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Tanks</p>
                        <p class="col-xs-6 livecard-image"><img src="../../../../assets/img/ambrolive_imgs/tanks.png"
                                                                height="50" width="50"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{currentDayCustomerPonds && currentDayCustomerPonds.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--harvest-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#harvestModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{harvestLogs && harvestLogs.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Harvest</p>
                        <p class="col-xs-6 livecard-image"><img src="../../../../assets/img/ambrolive_imgs/harvest.png"
                                                                height="50" width="50"/>
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{harvestLogs && harvestLogs.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Service request-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#todaySRModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{serviceRequests && serviceRequests.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Service Request</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/service-request.png" height="50" width="50"/>
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{serviceRequests && serviceRequests.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Images -- When farmer login-->
                  <!--Images-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview"
                       *ngIf="(loginPersonType == 'Farmer' || loginPersonType == 'Business Admin') && loginBusinessCategory == 'Farm'">
                    <div class="content colour-1">
                      <div 
                        class="row handSymbol" 
                        (click)="onImagesClick()">
                        <p class="col-xs-6 card-heading">Images</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/images.png" height="50" width="50" />
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{imageCount && imageCount}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row row-flex secondrow">
                  <!--meal-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#mealModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{feedLogs && feedLogs.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Meal</p>
                        <p class="col-xs-6 livecard-image"><img src="../../../../assets/img/ambrolive_imgs/meals.png"
                                                                height="50" width="50"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{feedLogs && feedLogs.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--water quality-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div routerLink="/home/newwaterquality"
                           class="{{waterQualityTest && waterQualityTest>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Water Quality</p>
                        <p class="col-xs-6 livecard-image"><img
                          src="../../../../assets/img/ambrolive_imgs/waterquality.png" height="50" width="50"/>
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{waterQualityTest}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Treatments-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#treatmentModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{treatmentLogs && treatmentLogs.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Treatments</p>
                        <p class="col-xs-6 livecard-image cardImages"><img
                          src="../../../../assets/img/ambrolive_imgs/treatment.png" height="50" width="50"/>
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{treatmentLogs && treatmentLogs.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Observation-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#observationModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{observationLogs && observationLogs.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Observation</p>
                        <p class="col-xs-6 livecard-image">
                          <img class="obsimage" src="../../../../assets/img/new_icons/observations.png"
                               height="32" width="32"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count"
                           style="margin-top: 18px;">{{observationLogs && observationLogs.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--sampling-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview">
                    <div class="content colour-1">
                      <div data-toggle="modal" data-target="#samplingModal"
                           data-backdrop="static" data-keyboard="false"
                           class="{{samplings && samplings.length>0?'':'noCursorCls'}} row handSymbol">
                        <p class="col-xs-6 card-heading">Sampling</p>
                        <p class="col-xs-6 livecard-image"><img src="../../../../assets/img/ambrolive_imgs/sampling.png"
                                                                height="50" width="50"/></p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{samplings && samplings.length}}</p>
                      </div>
                    </div>
                  </div>
                  <!--Images-->
                  <div class="col-lg-2 col-md-4 col-sm-6 col-xs-12 mobileview"
                       *ngIf="loginPersonType == 'EMPLOYEE' || loginPersonType == 'Farm Manager'">
                    <div class="content colour-1">
                      <div 
                        class="row handSymbol" 
                        (click)="onImagesClick()">
                        <p class="col-xs-6 card-heading">Images</p>
                        <p class="col-xs-6 livecard-image">
                          <img src="../../../../assets/img/ambrolive_imgs/images.png" height="50" width="50" />
                        </p>
                      </div>
                      <div class="row">
                        <p class="card-count">{{imageCount && imageCount}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Summary overview block-->
  <div class="row">
    <h2 class="summary_overview_text">Summary Overview</h2>
    <div class="row">
      <div class="summary_overview_block">
        <div class="row summary_heading">
          <div class="col-xs-6 total_farms" *ngIf="appPermission.businessAdminFarmCount">
            <span class="farms_number">{{businessEntities && businessEntities.totalFarms}}</span> <span> Farm(s)</span>
          </div>
          <div class="col-xs-6 total_farms" *ngIf="appPermission.farmersCountFlag">
            <span class="farms_number">{{farmsCount}}</span><span> Farm(s)</span>
          </div>
          <div class="col-xs-6 total_farms" *ngIf="appPermission.employeeFarmsCount">
            <span class="farms_number">{{farmsCount}}</span><span> Farm(s)</span>
          </div>
          <div class="col-xs-6 view_all">
            <span>VIEW ALL <i class="fa fa-caret-right" aria-hidden="true"></i></span><span></span>
          </div>
        </div>
        <hr>
        <div class="row">
          <!--sites-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" data-toggle="modal"
                 data-target="#allSitesModal"
                 data-backdrop="static" data-keyboard="false">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/SITES.png" height="79" width="79"/>
              </div>
              <div class="summary_label_text handSymbol">
                <h2>{{feedLogsWithFarmSite && feedLogsWithFarmSite.length || 0}} Sites</h2>
              </div>
            </div>
          </div>
          <!--sections-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" data-toggle="modal"
                 data-target="#allsectionModal"
                 data-backdrop="static" data-keyboard="false">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/SECTIONS.png" height="78" width="78"/>
              </div>
              <div class="summary_label_text handSymbol">
                <h2>{{pondSections && pondSections.length || 0}} Sections</h2>
              </div>
            </div>
          </div>
          <!--ponds-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" routerLink="/home/totalpondslist">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/PONDS.png" height="79" width="79"/>
              </div>
              <div class="summary_label_text handSymbol">
                <h2 class="summarypond">{{activePondCount | currencyFormat}} Ponds</h2>
                <p class="summaryinactive_data">Out of {{inActivePondsCount | currencyFormat}} Inactive</p>
              </div>
            </div>
          </div>
          <!--species-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" data-toggle="modal"
                 data-target="#allspeciesModal"
                 data-backdrop="static" data-keyboard="false">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/SPECIES.png" height="78" width="78"/>
              </div>
              <div class="summary_label_text NoborderRight handSymbol">
                <h2>{{speciesType && speciesType.speciesCount}} Species</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!--Area-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" routerLink="/home/totalarealist">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/AREA.png" height="79" width="79"/>
              </div>
              <div class="summary_label_text handSymbol">
                <h2 class="summarypond">{{activeArea | currencyFormat}} Area</h2>
                <p class="summaryinactive_data">Out of {{inActiveArea | currencyFormat}} ha Inactive</p>
              </div>
            </div>
          </div>
          <!--Stocking-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" routerLink="/home/totalstockinglist">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/STOCKING.png" height="78" width="78"/>
              </div>
              <div class="summary_label_text summary_stocking_label handSymbol">
                <h2 class="summarypond summary_stocking">{{activeStockingCount | currencyFormat}} Stocking</h2>
                <p class="summaryinactive_data">Out of {{inActiveStockingCount | currencyFormat}} Harvested</p>
              </div>
            </div>
          </div>
          <!--Device-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div
              class=" {{customerDevices && customerDevices.length ?'':'noCursorCls'}} card cardIcon waves-effect waves-dark Summary_card"
              routerLink="/home/totaldeviceslist">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/DEVICES.png" height="78" width="78"/>
              </div>
              <div class="summary_label_text handSymbol">
                <h2>{{customerDevices && customerDevices.length}} Devices</h2>
              </div>
            </div>
          </div>
          <!--Users-->
          <div class="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <div class="card cardIcon waves-effect waves-dark Summary_card" data-toggle="modal"
                 data-target="#allusersModal"
                 data-backdrop="static" data-keyboard="false">
              <div class="card-image">
                <img src="../../../../assets/img/new_dasboard_imges/PERSONS.png" height="79" width="79"/>
              </div>
              <div class="summary_label_text NoborderRight handSymbol">
                <h2>{{persons && persons.length}} Users</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--today meal popup-->
  <div class="modal fade" id="mealModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Meal</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel panel-default">
                  <div class="panel-body table-responsive">
                    <table class="table table-striped table-hover">
                      <thead>
                      <tr>
                        <th>S.No</th>
                        <th>FARM NAME</th>
                        <th>FARM SITE</th>
                        <th>SECTION</th>
                        <th>POND NAME</th>
                        <th>GIVEN TIME</th>
                        <th>UPDATED ON</th>
                        <th>MEAL QTY(Kgs)</th>
                        <th>MEAL CONSUMED(Kgs)</th>
                        <th>QTY IN CHECK TRY(gms)</th>
                        <th>IMAGES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                        *ngFor="let list of feedLogs |  paginate: { id: 'meal', itemsPerPage: mealNoOfItemsPerPage, currentPage: mealCurrentPageNumber }; let i = index">
                        <td>{{((mealCurrentPageNumber - 1) * mealNoOfItemsPerPage) + i + 1}}</td>
                        <td>{{list.FarmSiteDetails[0].businessID.businessName}}</td>
                        <td>{{list.FarmSiteDetails[0].farmNameAtLocation}}</td>
                        <td>{{list.section_name}}</td>
                        <td>{{list.name}}</td>
                        <td>{{list.given_time}}</td>
                        <td>{{(list.createddate + ' ' + list.createdAttime) | date:"dd-MMM-yyyy hh:mm:ss a"}}</td>
                        <td>{{(list.meal_given / 1000) | currencyFormat}}</td>
                        <td>{{(list.meal_consumed / 1000) | currencyFormat}}</td>
                        <td>{{list.check_tray_feed_given | currencyFormat}}</td>
                        <td
                          *ngIf="appPermission.businessAdminFarmCount || appPermission.farmersCountFlag">{{list.imagecount}}
                          <span *ngIf="list.imagecount>0" (click)="getAllImageDownload(list)"><i
                            class="fa fa-picture-o meal_images" aria-hidden="true"></i></span></td>
                        <td *ngIf="appPermission.employeeFarmsCount">{{list.imagecount}}</td>
                      </tr>
                      </tbody>
                    </table>
                    <div class="dashboard-pagination-container items-per-page-container" *ngIf="feedLogs && feedLogs.length > 0">
                      <div class="items-per-page-block">
                        <span class="items-per-page">Items per page</span>
                        <div class="items-per-page-count-list form-field">
                          <select class="form-control select" autocomplete="off"
                                  (change)="mealNoOfItemsPerPage = $event.target.value;mealCurrentPageNumber = 1;">
                            <option value="15" selected>15</option>
                            <option value="25" *ngIf="feedLogs && feedLogs.length > 15">25</option>
                            <option value="35" *ngIf="feedLogs && feedLogs.length > 25">35</option>
                            <option value="45" *ngIf="feedLogs && feedLogs.length > 35">45</option>
                          </select>
                          <span class="pagination-custom-down-arrow"></span>
                        </div>
                        <span class="items-per-page">1 - {{mealNoOfItemsPerPage}} of {{feedLogs && feedLogs.length}}
                          items</span>
                      </div>
                      <div class="page-selection-div" *ngIf="mealNoOfItemsPerPage != feedLogs.length">
                        <pagination-controls id="meal" (pageChange)="mealCurrentPageNumber = $event"
                                             maxSize="5"></pagination-controls>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div *ngIf="imagesList && imagesList.length>0" [hidden]="!pgLoad">
                      <div class="col-md-3" *ngFor="let imageObj of imagesList" [hidden]="!pgLoad">
                        <div class="thumbnail" [hidden]="!pgLoad">
                          <div>
                            <img [src]="transform(imageObj['image'])" id="myImg" (click)="imageHideShow(imageObj)"
                                 data-toggle="modal" data-target="#myModal" width="100%">
                            <p>Date: {{imageObj['Updated_on']}}</p>
                            <p>Meal: {{imageObj['meal']}}</p>
                          </div>
                        </div>
                        <!--Model imges display-->
                        <div class="modal fade" id="myModal" role="dialog" *ngIf="selectedImageObj">
                          <div class="modal-dialog">
                            <!-- Modal content-->
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" title="Close Popup" class="close" data-dismiss="modal"
                                        (click)="closeModel()">
                                  &times;
                                </button>
                              </div>
                              <div class="modal-body">
                                <img class="model_popup_image" [src]="transform(selectedImageObj['image'])">
                              </div>
                              <div class="modal-footer">
                                <!--<button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeModel()">Close</button>-->
                              </div>
                            </div>
                          </div>
                        </div>
                        <!--End Model imges display-->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--today meal popup end-->
  <!--today treatment popup-->
  <div class="modal fade" id="treatmentModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Treatment</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>FARM SITE</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>DATE</th>
                      <th>TIME</th>
                      <th>TREATMENT TYPE</th>
                      <th>QUANTITY</th>
                      <th>DESCRIPTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of treatmentLogs |  paginate: { id:'treatment', itemsPerPage: noOfTreatmentItemsPerPage, currentPage: currentTreatmentPageNumber }; let i = index">
                      <td>{{((currentTreatmentPageNumber - 1) * noOfTreatmentItemsPerPage) + i + 1}}</td>
                      <td>{{list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list.FarmSiteDetails[0].farmNameAtLocation}}</td>
                      <td>{{list.section_name}}</td>
                      <td>{{list.pond_name}}</td>
                      <td>{{list.date  | date:"dd-MMM-yyyy"}}</td>
                      <td>{{list.time}}</td>
                      <td *ngIf="list.othername != null">{{list.treatment_type + ' - ' + list.othername}}</td>
                      <td
                        *ngIf="list.othername == null">{{list.treatment_type}}</td>
                      <td>{{list.quantity | currencyFormat}} {{list.uom}}</td>
                      <td style="width: 30px;">{{list.description}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="treatmentLogs && treatmentLogs.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfTreatmentItemsPerPage = $event.target.value;currentTreatmentPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="treatmentLogs && treatmentLogs.length > 15">25</option>
                          <option value="35" *ngIf="treatmentLogs && treatmentLogs.length > 25">35</option>
                          <option value="45" *ngIf="treatmentLogs && treatmentLogs.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfTreatmentItemsPerPage}}
                        of {{treatmentLogs && treatmentLogs.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfTreatmentItemsPerPage != treatmentLogs.length">
                      <pagination-controls id="treatment" (pageChange)="currentTreatmentPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--today treatment popup end-->
  <!--observation modal popup-->
  <div class="modal fade" id="observationModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Observation</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>DATE</th>
                      <th>TIME</th>
                      <th>OBSERVATION TYPE</th>
                      <th>DOC</th>
                      <th style="width: 30px;">COMMENT</th>
                      <th>IMAGE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of observationLogs |  paginate: { id: 'observation', itemsPerPage: noOfObservationItemsPerPage, currentPage: currentObservationPageNumber }; let i = index">
                      <td>{{((currentObservationPageNumber - 1) * noOfObservationItemsPerPage) + i + 1}}</td>
                      <td>{{list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list.section_name}}</td>
                      <td>{{list.pond_name}}</td>
                      <td>{{list.date  | date:"dd-MMM-yyyy"}}</td>
                      <td>{{list.time}}</td>
                      <td>{{list.observationtype}}</td>
                      <td>{{list.DOC}}</td>
                      <td>{{list.comment}}</td>
                      <td
                        *ngIf="appPermission.businessAdminFarmCount || appPermission.farmersCountFlag">{{list.imagecount}}
                        <span *ngIf="list.imagecount>0" (click)="getAllImageDownload(list)"><i
                          class="fa fa-picture-o meal_images" aria-hidden="true"></i></span></td>
                      <td *ngIf="appPermission.employeeFarmsCount">{{list.imagecount}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="observationLogs && observationLogs.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfObservationItemsPerPage = $event.target.value;currentTreatmentPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="observationLogs && observationLogs.length > 15">25</option>
                          <option value="35" *ngIf="observationLogs && observationLogs.length > 25">35</option>
                          <option value="45" *ngIf="observationLogs && observationLogs.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfObservationItemsPerPage}}
                        of {{observationLogs && observationLogs.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfObservationItemsPerPage != observationLogs.length">
                      <pagination-controls id="observation" (pageChange)="currentObservationPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--observation modal popup end-->
  <!--sampling modal popup-->
  <div class="modal fade" id="samplingModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Sampling</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover" id="dataTables-example">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>FARM SITE</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>DATE</th>
                      <th>FCR</th>
                      <th>ABW(Grams)</th>
                      <th>TOTAL BIOMASS(Kgs)</th>
                      <th>CUMULATIVE FEED(Kgs)</th>
                      <th>SURVIVAL RATE</th>
                      <th>COUNT<br>(Animals/Kg)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of samplings |  paginate: { id: 'sampling', itemsPerPage: noOfSamplingItemsPerPage, currentPage: currentSamplingPageNumber}; let i = index">
                      <td>{{((currentSamplingPageNumber - 1) * noOfSamplingItemsPerPage) + i + 1}}</td>
                      <td>{{list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list.FarmSiteDetails[0].farmNameAtLocation}}</td>
                      <td>{{list.section_name}}</td>
                      <td>{{list.pond_name}}</td>
                      <td>{{list.date  | date:"dd-MMM-yyyy"}}</td>
                      <td>{{(list.FCR == null) ? 'NA' : (list.FCR | currencyFormat)}}</td>
                      <td>{{list.ABW == null ? 'NA' : (list.ABW)}}</td>
                      <td>{{list.total_biomass == null ? 'NA' : (list.total_biomass)}}</td>
                      <td>{{list.cumulative_feed == null ? 'NA' : (list.cumulative_feed / 1000) | currencyFormat}}</td>
                      <td>{{(list.survival_rate == null) ? 'NA' : (list.survival_rate) | currencyFormat}}</td>
                      <td>{{list.COUNT | currencyFormat}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="samplings && samplings.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" id="itemscount" autocomplete="off"
                                (change)="noOfSamplingItemsPerPage = $event.target.value;currentSamplingPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="samplings && samplings.length > 15">25</option>
                          <option value="35" *ngIf="samplings && samplings.length > 25">35</option>
                          <option value="45" *ngIf="samplings && samplings.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfSamplingItemsPerPage}}
                        of {{samplings && samplings.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfSamplingItemsPerPage != samplings.length">
                      <pagination-controls id='sampling' (pageChange)="currentSamplingPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--sampling modal popup end-->
  <!--Today sr modalpopup-->
  <div class="modal fade" id="todaySRModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Service Request</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>SR START DATE</th>
                      <th>FARM NAME
                      </th>
                      <th>SERIAL NUMBER
                      </th>
                      <th>ISSUE TYPE
                      </th>
                      <th>STATUS</th>
                      <th style="width: 20%;">DESCRIPTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of serviceRequests |  paginate: { id: 'sr', itemsPerPage: noOfSrItemsPerPage, currentPage: currentSrPageNumber }; let i = index">
                      <td>{{((currentSrPageNumber - 1) * noOfSrItemsPerPage) + i + 1}}</td>
                      <td>{{list.sr_start_date | date:"dd-MMM-yyyy"}}</td>
                      <td>{{list.BusinessDetails[0].businessName}}</td>
                      <td>{{list && list.device && list.device.serial_number}}</td>
                      <td>{{list && list.srTopics && list.srTopics.name}}</td>
                      <td>{{list && list.ssCode && list.ssCode.code}}</td>
                      <td>{{list.description}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="serviceRequests && serviceRequests.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfSrItemsPerPage = $event.target.value;currentSrPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="serviceRequests && serviceRequests.length > 15">25</option>
                          <option value="35" *ngIf="serviceRequests && serviceRequests.length > 25">35</option>
                          <option value="45" *ngIf="serviceRequests && serviceRequests.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfSrItemsPerPage}}
                        of {{serviceRequests && serviceRequests.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfSrItemsPerPage != serviceRequests.length">
                      <pagination-controls id='sr' (pageChange)="currentSrPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--Today sr modalpopup end-->
  <!--Today harvest madal popup-->
  <div class="modal fade" id="harvestModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Harvest</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>DATE</th>
                      <th>TIME</th>
                      <th>WEIGHT(Kgs)</th>
                      <th>COUNT</th>
                      <th>No. OF ANIMALS</th>
                      <th>HARVESTED TYPE</th>
                      <th>CUMULATIVE FEED(Kgs)</th>
                      <th>ABW(gms)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of harvestLogs |  paginate: { id: 'harvest', itemsPerPage: noOfHarvestItemsPerPage, currentPage: currentHarvestPageNumber }; let i = index">
                      <td>{{((currentHarvestPageNumber - 1) * noOfHarvestItemsPerPage) + i + 1}}</td>
                      <td>{{list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list.sectionName}}</td>
                      <td>{{list.pondName}}</td>
                      <td>{{list.date | date:"dd-MMM-yyyy"}}</td>
                      <td>{{list.time == null ? 'NA' : list.time}}</td>
                      <td>{{list.weight | currencyFormat}}</td>
                      <td>{{(list.count == null) ? 'NA' : (list.count) | currencyFormat}}</td>
                      <td>{{list.noofanimals | currencyFormat}}</td>
                      <td>{{list.harvestmode}}</td>
                      <td>{{(list.cumulative_feed / 1000) | currencyFormat}}</td>
                      <td>{{(list.abw == null) ? 'NA' : (list.abw) | currencyFormat}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="harvestLogs && harvestLogs.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfHarvestItemsPerPage = $event.target.value;currentHarvestPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="harvestLogs && harvestLogs.length > 15">25</option>
                          <option value="35" *ngIf="harvestLogs && harvestLogs.length > 25">35</option>
                          <option value="45" *ngIf="harvestLogs && harvestLogs.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfHarvestItemsPerPage}}
                        of {{harvestLogs && harvestLogs.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfHarvestItemsPerPage != harvestLogs.length">
                      <pagination-controls id='harvest' (pageChange)="currentHarvestPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--Today harvest madal popup end-->
  <!--culture modal popup-->
  <div class="modal fade" id="cultureModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Culture</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>LOCATION</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>CULTURE START DATE</th>
                      <th>SIZE(Acres)</th>
                      <th>DIAMETER</th>
                      <th>STOCKING</th>
                      <th>WATER TYPE</th>
                      <th>SOIL TYPE</th>
                      <th>SPECIES TYPE</th>
                      <th>STOCKING DENSITY(pl/m2)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of pondCultures |  paginate: { id: 'culture', itemsPerPage: noOfCultureItemsPerPage, currentPage: currentCulturePageNumber }; let i = index">
                      <td>{{((currentCulturePageNumber - 1) * noOfCultureItemsPerPage) + i + 1}}</td>
                      <td>{{list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].businessID && list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.district + ', ' + list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.village}}</td>
                      <td>{{list && list.pond && list.pond.PondSection && list.pond.PondSection.section_name}}</td>
                      <td>{{list && list.pond && list.pond.name}}</td>
                      <td>{{list.start_date | date:"dd-MMM-yyyy"}}</td>
                      <td>{{(list && list.pond && list.pond.pond_size == 0) ? '--' : (list && list.pond && list.pond.pond_size | currencyFormat)}}</td>
                      <td>{{(list && list.pond && list.pond.tank_diameter == 0) ? '--' : (list && list.pond && list.pond.tank_diameter | currencyFormat)}}</td>
                      <td>{{list.stocking_count | currencyFormat}}</td>
                      <td>{{list && list.waterType && list.waterType.name}}</td>
                      <td>{{list && list.soilType && list.soilType.name}}</td>
                      <td>{{list && list.speciesType && list.speciesType.name}}</td>
                      <td>{{(list && list.stocking_density == null) ? '--' : list && list.stocking_density | currencyFormat}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="pondCultures && pondCultures.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfCultureItemsPerPage = $event.target.value;currentCulturePageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="pondCultures && pondCultures.length > 15">25</option>
                          <option value="35" *ngIf="pondCultures && pondCultures.length > 25">35</option>
                          <option value="45" *ngIf="pondCultures && pondCultures.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfCultureItemsPerPage}}
                        of {{pondCultures && pondCultures.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfCultureItemsPerPage != pondCultures.length">
                      <pagination-controls id='culture' (pageChange)="currentCulturePageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--culture modal popup end-->
  <!--today provider modal popup-->
  <div class="modal fade" id="todayProviderModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Providers</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Provider Name</th>
                      <th>Farm Name</th>
                      <th>Farmsite Name</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of providerBusinessEntities |  paginate: { id: 'providers', itemsPerPage: noOfProviderItemsPerPage, currentPage: currentProviderPageNumber }; let i = index">
                      <td>{{((currentProviderPageNumber - 1) * noOfProviderItemsPerPage) + i + 1}}</td>
                      <td>{{list.businessName}}</td>
                      <td>{{(list && list.FarmSiteBusinessEntity && list.FarmSiteBusinessEntity.length > 0 && list.FarmSiteBusinessEntity[0].businessID && list.FarmSiteBusinessEntity[0].businessID.businessName) || 'NA'}}</td>
                      <td>{{(list && list.FarmSiteBusinessEntity && list.FarmSiteBusinessEntity.length > 0 && list.FarmSiteBusinessEntity[0].farmNameAtLocation) || 'NA'}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container"
                       *ngIf="providerBusinessEntities && providerBusinessEntities.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfProviderItemsPerPage = $event.target.value;currentProviderPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="providerBusinessEntities && providerBusinessEntities.length > 15">
                            25
                          </option>
                          <option value="35" *ngIf="providerBusinessEntities && providerBusinessEntities.length > 25">
                            35
                          </option>
                          <option value="45" *ngIf="providerBusinessEntities && providerBusinessEntities.length > 35">
                            45
                          </option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfHarvestItemsPerPage}}
                        of {{providerBusinessEntities && providerBusinessEntities.length}} items</span>
                    </div>
                    <div class="page-selection-div"
                         *ngIf="noOfProviderItemsPerPage != providerBusinessEntities.length">
                      <pagination-controls id='providers' (pageChange)="currentProviderPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--today provider modal popup end-->
  <!--today farms-->
  <div class="modal fade" id="todayFarmModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Farms</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Farmsite Name</th>
                      <th>Farm Name</th>
                      <th>Address</th>
                      <th>Ownership</th>
                      <th>Water Type</th>
                      <th>Soil Type</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of currentDayFarmSites |  paginate: { id: 'farms', itemsPerPage: noOfFarmItemsPerPage, currentPage: currentFarmPageNumber }; let i = index">
                      <td>{{((currentFarmPageNumber - 1) * noOfFarmItemsPerPage) + i + 1}}</td>
                      <td>{{list.farmNameAtLocation}}</td>
                      <td>{{(list && list.businessID == null) ? '--' : (list && list.businessID && list.businessID.businessName)}}</td>
                      <td>{{(list && list.address && list.address.village) + ', ' + (list && list.address && list.address.district)}}</td>
                      <td>{{list && list.ownership}}</td>
                      <td>{{list && list.waterType && list.waterType.name}}</td>
                      <td>{{list && list.soilType && list.soilType.name}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="currentDayFarmSites && currentDayFarmSites.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfFarmItemsPerPage = $event.target.value;currentFarmPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="currentDayFarmSites && currentDayFarmSites.length > 15">25
                          </option>
                          <option value="35" *ngIf="currentDayFarmSites && currentDayFarmSites.length > 25">35
                          </option>
                          <option value="45" *ngIf="currentDayFarmSites && currentDayFarmSites.length > 35">45
                          </option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfFarmItemsPerPage}}
                        of {{currentDayFarmSites && currentDayFarmSites.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfFarmItemsPerPage != currentDayFarmSites.length">
                      <pagination-controls id='farms' (pageChange)="currentFarmPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--today farms end-->
  <!--today tanks madal popup-->
  <div class="modal fade" id="todayTanksModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Today Tanks</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>LOCATION</th>
                      <th>SECTION</th>
                      <th>POND NAME</th>
                      <th>SPECIES TYPE</th>
                      <th>STOCKING DENSITY</th>
                      <th>DATE</th>
                      <th>TANK CODE</th>
                      <th>SIZE(Acres)</th>
                      <th>DIAMETER</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of currentDayCustomerPonds |  paginate: { id: 'tanks', itemsPerPage: noOfTanksItemsPerPage, currentPage: currentTanksPageNumber }; let i = index">
                      <td>{{((currentTanksPageNumber - 1) * noOfTanksItemsPerPage) + i + 1}}</td>
                      <td>{{list && list.FarmSiteDetails && list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list && list.FarmSiteDetails && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.district + ', ' + list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.village}}
                      </td>
                      <td>{{list && list.PondSection && list.PondSection.section_name}}</td>
                      <td>{{list.name}}</td>
                      <td>{{(list && list.PondCultureData.length > 0 && list.PondCultureData[0] && list.PondCultureData[0].speciesType && list.PondCultureData[0].speciesType.name) || 'NA'}}</td>
                      <td>{{(list && list.stocking_density == null) ? '--' : list && list.stocking_density | currencyFormat}}</td>
                      <td>{{list.createdAt | date:"dd-MMM-yyyy" }}</td>
                      <td>{{list.pond_code}}</td>
                      <td>{{(list.pond_size == 0) ? '--' : (list.pond_size | currencyFormat)}}</td>
                      <td>{{(list.tank_diameter == 0) ? '--' : list.tank_diameter}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container"
                       *ngIf="currentDayCustomerPonds && currentDayCustomerPonds.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfTanksItemsPerPage = $event.target.value;currentTanksPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="currentDayCustomerPonds && currentDayCustomerPonds.length > 15">
                            25
                          </option>
                          <option value="35" *ngIf="currentDayCustomerPonds && currentDayCustomerPonds.length > 25">
                            35
                          </option>
                          <option value="45" *ngIf="currentDayCustomerPonds && currentDayCustomerPonds.length > 35">
                            45
                          </option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfTanksItemsPerPage}}
                        of {{currentDayCustomerPonds && currentDayCustomerPonds.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfTanksItemsPerPage != currentDayCustomerPonds.length">
                      <pagination-controls id='tanks' (pageChange)="currentTanksPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--today tanks end-->
  <!--all sections-->
  <div class="modal fade" id="allsectionModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Sections</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME</th>
                      <th>LOCATION</th>
                      <th>SECTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let list of pondSections |  paginate: { id: 'sections', itemsPerPage: sectionNoOfItemsPerPage, currentPage: sectionCurrentPageNumber };  let i = index">
                      <td>{{((sectionCurrentPageNumber - 1) * sectionNoOfItemsPerPage) + i + 1}}</td>
                      <td>{{list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].businessID && list.FarmSiteDetails[0].businessID.businessName}}</td>
                      <td>{{list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.district + ',' + list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.village}}</td>
                      <td>{{list.section_name}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <div class="row">
                    <!--pagination-->
                    <div class="reports-pagination-container" *ngIf="pondSections && pondSections.length > 15">
                      <div class="items-per-page-block">
                        <span class="items-per-page">Items per page</span>
                        <div class="items-per-page-count-list form-field">
                          <select class="form-control select" autocomplete="off"
                                  (change)="sectionNoOfItemsPerPage = $event.target.value;sectionCurrentPageNumber = 1;
                                  pondSections = originalPondSections; search = '';NoDataMessage = false">
                            <option value="15" selected>15</option>
                            <option value="25" *ngIf="originalPondSections && originalPondSections.length > 15">25</option>
                            <option value="35" *ngIf="originalPondSections && originalPondSections.length > 25">35</option>
                            <option value="45" *ngIf="originalPondSections && originalPondSections.length > 35">45</option>
                          </select>
                          <span class="pagination-custom-down-arrow"></span>
                        </div>
                        <span class="items-per-page">1 - {{sectionNoOfItemsPerPage}}
                          of {{originalPondSections && originalPondSections.length}} items</span>
                      </div>
                      <div class="page-selection-div" *ngIf="sectionNoOfItemsPerPage != pondSections.length">
                        <pagination-controls id='sections' (pageChange)="sectionCurrentPageNumber = $event"
                                             maxSize="5"></pagination-controls>
                      </div>
                    </div>
                    <!--pagination end-->
                  </div>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--all sections end-->
  <!--all species-->
  <div class="modal fade" id="allspeciesModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" title="Close Popup">&times;</button>
          <h4 class="modal-title">Species</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARMSITE NAME</th>
                      <th>LOCATION</th>
                      <th>SPECIES NAME</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="searchfun"
                        *ngFor="let list of speciesTypes |  paginate: { id: 'species', itemsPerPage: noOfSpeciesItemsPerPage, currentPage: currentSpeciesPageNumber }; let i = index">
                      <td>{{((currentSpeciesPageNumber - 1) * noOfSpeciesItemsPerPage) + i + 1}}</td>
                      <td>{{list.FarmSiteDetails && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].farmNameAtLocation}}</td>
                      <td>{{list.FarmSiteDetails && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address.village + ', ' + list.FarmSiteDetails && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].address.district}}</td>
                      <td>{{list.speciesName}}</td>
                    </tr>
                    </tbody>
                  </table>
                  <!--pagination-->
                  <div class="dashboard-pagination-container items-per-page-container" *ngIf="speciesTypes && speciesTypes.length > 0">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" autocomplete="off"
                                (change)="noOfSpeciesItemsPerPage = $event.target.value;currentSpeciesPageNumber = 1;">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="speciesTypes && speciesTypes.length > 15">25</option>
                          <option value="35" *ngIf="speciesTypes && speciesTypes.length > 25">35</option>
                          <option value="45" *ngIf="speciesTypes && speciesTypes.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfSpeciesItemsPerPage}}
                        of {{speciesTypes && speciesTypes.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfSpeciesItemsPerPage != speciesTypes.length">
                      <pagination-controls id='species' (pageChange)="currentSpeciesPageNumber = $event"
                                           maxSize="5"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--all species end-->
  <!--users all-->
  <div class="modal fade" id="allusersModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" title="Close Popup">&times;</button>
          <h4 class="modal-title">Users</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <div class="page-content-wrap">
            <!-- Contenet page started-->
            <div class="row">
              <div class="col-md-12">
                <!-- START BASIC TABLE SAMPLE -->
                <div class="panel-body table-responsive">
                  <table class="table table-striped table-hover">
                    <thead>
                    <tr>
                      <th>S.No</th>
                      <th>FARM NAME
                      </th>
                      <th>NAME
                      </th>
                      <th>PERSON TYPE
                      </th>
                      <th>PHONE NUMBER
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let list of persons; let i = index">
                      <td>{{((currentPageNumber - 1) * noOfItemsPerPage) + i + 1}}</td>
                      <td>{{list && list.businessID && list.businessID.businessName}}</td>
                      <td>{{list.firstName + ' ' + list.lastName}}</td>
                      <td>{{list.personType[0] && list.personType[0].name}}</td>
                      <td>{{list.mobileNumber}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!-- END BASIC TABLE SAMPLE -->
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit">
            <img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--users all end-->
  <!--all Sites-->
  <div class="modal fade" id="allSitesModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" title="Close Popup">&times;</button>
          <h4 class="modal-title">Sites</h4>
        </div>
        <div class="modal-body">
          <!-- PAGE CONTENT WRAPPER -->
          <!-- Contenet page started-->
          <div class="row">
            <div class="col-md-12">
              <!-- START BASIC TABLE SAMPLE -->
              <div class="panel-body table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                  <tr>
                    <th>S.No</th>
                    <th>FARM NAME</th>
                    <th>NO.SECTIONS</th>
                    <th>NO.PONDS</th>
                    <th>SITE</th>
                    <th>BIOMASS(Kgs)</th>
                    <th>CONSUMPTION(Kgs)</th>
                    <th>SURVIVAL RATE</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="searchfun"
                      *ngFor="let list of feedLogsWithFarmSite | paginate: { id: 'feedlogsites', itemsPerPage: noOfTotalSitesItemsPerPage, currentPage: currentTotalSitesPageNumber }; let i = index">
                    <td>{{((currentTotalSitesPageNumber - 1) * noOfTotalSitesItemsPerPage) + i + 1}}</td>
                    <td>{{list && list.FarmSiteDetails && list.FarmSiteDetails[0].businessID && list.FarmSiteDetails[0].businessID.businessName}}</td>
                    <td>{{list.noofsections}}</td>
                    <td>{{list.noofponds}}</td>
                    <td>{{list && list.FarmSiteDetails && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.district + ',' + list && list.FarmSiteDetails && list.FarmSiteDetails[0].address && list.FarmSiteDetails[0].address.village}}</td>
                    <td>{{(list.FarmSummary.totalBiomass / 1000) | currencyFormat}}</td>
                    <td>{{(list.FarmSummary.totalConsumption / 1000) | currencyFormat}}</td>
                    <td>{{list.FarmSummary.survivalRate | currencyFormat}}</td>
                  </tr>
                  </tbody>
                </table>
                <div class="row">
                  <!--pagination-->
                  <div class="reports-pagination-container" *ngIf="feedLogsWithFarmSite && feedLogsWithFarmSite.length > 15">
                    <div class="items-per-page-block">
                      <span class="items-per-page">Items per page</span>
                      <div class="items-per-page-count-list form-field">
                        <select class="form-control select" id="itemscount" autocomplete="off" (change)="noOfTotalSitesItemsPerPage = $event.target.value;currentTotalSitesPageNumber = 1;
                        feedLogsWithFarmSite = originalFeedLogsWithFarmSite; search = '';NoDataMessage = false">
                          <option value="15" selected>15</option>
                          <option value="25" *ngIf="originalFeedLogsWithFarmSite && originalFeedLogsWithFarmSite.length > 15">25</option>
                          <option value="35" *ngIf="originalFeedLogsWithFarmSite && originalFeedLogsWithFarmSite.length > 25">35</option>
                          <option value="45" *ngIf="originalFeedLogsWithFarmSite && originalFeedLogsWithFarmSite.length > 35">45</option>
                        </select>
                        <span class="pagination-custom-down-arrow"></span>
                      </div>
                      <span class="items-per-page">1 - {{noOfTotalSitesItemsPerPage}} of {{originalFeedLogsWithFarmSite && originalFeedLogsWithFarmSite.length}} items</span>
                    </div>
                    <div class="page-selection-div" *ngIf="noOfTotalSitesItemsPerPage != feedLogsWithFarmSite.length">
                      <pagination-controls (pageChange)="currentTotalSitesPageNumber = $event" maxSize="5" id="feedlogsites"></pagination-controls>
                    </div>
                  </div>
                  <!--pagination end-->
                </div>
              </div>
              <!-- END BASIC TABLE SAMPLE -->
            </div>
          </div>
        </div>
        <div class="modal-footer ambrolive-popup-close">
          <button class="center-block submitbtn" data-dismiss="modal"
                  type="submit"><img src="assets/images/New_Icons/close.svg">Close
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--all sections end-->
</div>
